<template>
  <div class="position-relative">
    <d-card-header class="border-bottom flex-header">
      <div class="d-flex flex-column">
        <h6 class="m-0">Bonifikaty do umowy</h6>
      </div>
      <d-button
        theme="primary"
        @click.prevent="addNew"
        :disabled="isLoading || allDiscountTypes.loadError">
        <i class="material-icons">add</i>Dodaj bonifikatę
      </d-button>
    </d-card-header>
    <d-card-body class="p-0 pb-3 text-center">
      <template v-if="allDiscountTypes.loadError">
        <d-alert
          show
          theme="warning">
          Wczytywanie danych nie powiodło się.
          <a
              href="javascript:window.location.reload();"
              class="alert-link">
              Odśwież stronę
          </a>
          aby spróbować ponownie.
        </d-alert>
      </template>
      <div v-else-if="isLoading" style="min-height: 80px;">
        <h2 class="preloader isLoading mt-4">Trwa ładowanie</h2>
      </div>
      <template v-else>
        <d-alert
          show
          theme="warning"
          class="my-3 mx-4">
          Aby zatwierdź modyfikacje bonifikat należy zapisać umowę.
        </d-alert>

        <table class="table mb-0 responsive-table">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0 id-cell text-left">Nazwa</th>
              <th scope="col" class="border-0 id-cell text-left">Typ</th>
              <th scope="col" class="border-0 id-cell text-right" style="max-width: 100px;">Wartość PLN</th>
              <th scope="col" class="border-0 id-cell text-right" style="max-width: 80px;">Wartość %</th>
              <th scope="col" class="border-0 id-cell text-right">Data spełnienia warunku</th>
              <th scope="col" class="border-0 id-cell text-right">Do spłaty wg umowy</th>
              <th scope="col" class="border-0 id-cell text-right">Do spłaty na dzień dzisiejszy</th>
              <th scope="col" class="border-0 id-cell" style="max-width: 80px;">Warunek spełniony</th>
              <th scope="col" class="border-0 id-cell action-cell">Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(discount, index) in discounts"
              :key="'discount-item-' + index">
              <td class="text-left">
                <dt>Nazwa</dt>
                <dd>{{ discount.discount_name}}</dd>
              </td>
              <td class="text-left">
                <dt>Typ</dt>
                <dd>{{ getDiscountTypeName(discount.discount_id)}}</dd>
              </td>
              <td class="text-right">
                <dt>Wartość PLN</dt>
                <dd>{{ toNumber(discount.discount_for_provision) || '-'}}</dd>
              </td>
              <td class="text-right">
                <dt>Wartość %</dt>
                <dd>{{ toNumber(discount.discount_value) || '-'}}</dd>
              </td>
              <td class="text-right">
                <dt>Data spełnienia warunku</dt>
                <dd>{{ discount.discount_date }}</dd>
              </td>
              <td class="text-right">
                <dt>Do spłaty wg umowy</dt>
                <dd>{{ toNumber(discount.discount_to_finish_credit_under_contract) }} zł</dd>
              </td>
              <td class="text-right">
                <dt>Do spłaty na dzień dzisiejszy</dt>
                <dd>{{ toNumber(discount.discount_to_finish_credit) }} zł</dd>
              </td>
              <td class="text-center">
                <dt>Warunek spełniony</dt>
                <dd>
                  <div class="d-flex">
                  <d-checkbox
                    class="mt-2 small yes-no mx-auto"
                    toggle
                    v-model="discount.discount_condition_met"
                    @change="updateContractDiscounts">
                  </d-checkbox>
                </div>
                </dd>
              </td>
              <td>
                <dt>Akcje</dt>
                <dd>
                  <d-button
                    @click.prevent="editItem(discount, index)"
                    class="mx-1 my-1"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                  <d-button
                    @click.prevent="removeItem(index)"
                    theme="danger"
                    class="mx-1 my-1"
                    title="Usuń">
                    <i class="material-icons">delete</i>
                  </d-button>
                  <d-button
                    v-if="!discount.discount_active"
                    @click.prevent="acceptItem(index)"
                    theme="success"
                    class="mx-1 my-1"
                    title="Zatwierdź"
                    :disabled="isDiscountGroupActive(discount) || !discount.discount_condition_met">
                    <i class="material-icons">done</i>
                  </d-button>
                  <d-button
                    v-if="discount.discount_active"
                    @click.prevent="unAcceptItem(index)"
                    theme="warning"
                    class="mx-1 my-1"
                    title="Wycofaj">
                    <i class="material-icons">close</i>
                  </d-button>
                </dd>
              </td>
            </tr>
            <tr v-if="discounts.length === 0">
              <td
                :colspan="9"
                class="text-center text-info">
                Brak bonifikat do wyświetlenia&hellip;
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </d-card-body>

    <discount-form-modal
      ref="discountFormModal"
      :discount-types="allDiscountTypes.data"
      @save-discount="saveDiscount" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DiscountFormModal from '@/components/client/contract-partials/discounts/DiscountFormModal.vue'

export default {
  name: 'ContractDiscounts',
  components: {
    DiscountFormModal
  },
  props: {
    discountsProp: {
      default: [],
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'allDiscountTypes'
    ]),
    isLoading () {
      return !this.allDiscountTypes || this.allDiscountTypes.isLoading;
    }
  },
  data () {
    return {
      discounts: []
    }
  },
  mounted () {
    if (!this.allDiscountTypes.data.length && !this.allDiscountTypes.isLoading) {
      this.getDiscountTypes();
    }
    let discountsCopy = JSON.parse(JSON.stringify(this.discountsProp));
    this.discounts = discountsCopy.map((item) => {
      return {
        ...item,
        discount_active: !!item.discount_active,
        discount_condition_met: !!item.discount_condition_met,
      };
    });
  },
  methods: {
    ...mapActions([
      'getDiscountTypes',
    ]),
    removeItem (itemIndex) {
      this.discounts.splice(itemIndex, 1);

      this.$nextTick(() => {
        this.updateContractDiscounts();
      })
    },
    editItem (selectedItem, selectedItemIndex) {
      this.$refs.discountFormModal.showModal(selectedItem, selectedItemIndex);

    },
    addNew () {
      this.$refs.discountFormModal.showModal();
    },
    acceptItem (itemIndex) {
      this.discounts[itemIndex].discount_active = true;

      this.$nextTick(() => {
        this.updateContractDiscounts();
      })
    },
    unAcceptItem (itemIndex) {
      this.discounts[itemIndex].discount_active = false;

      this.$nextTick(() => {
        this.updateContractDiscounts();
      })
    },
    saveDiscount (discount, discountIndex) {
      let itemCopy = JSON.parse(JSON.stringify(discount));
      if (discountIndex === null) {
        this.discounts.push(itemCopy);
      } else {
        Vue.set(this.discounts, discountIndex, itemCopy);
      }

      this.$nextTick(() => {
        this.updateContractDiscounts();
      })
    },
    // Bonifikata alokacyjna (payment_allocation) nie wyklucza się z klasycznymi
    // (odsetki/prowizja) — limit "jednej aktywnej" liczymy osobno w każdej grupie
    getDiscountGroup (typeID) {
      let discountType = this.allDiscountTypes.data.find(item => item.id === typeID);
      return discountType && discountType.type === 'payment_allocation' ? 'allocation' : 'classic';
    },
    isDiscountGroupActive (discount) {
      let group = this.getDiscountGroup(discount.discount_id);
      return !!this.discounts.find(item => item.discount_active && this.getDiscountGroup(item.discount_id) === group);
    },
    getDiscountTypeName (typeID) {
      let discountType = this.allDiscountTypes.data.find(item => item.id === typeID);
      if (!discountType) {
        return '-';
      }

      return discountType.name;
    },
    updateContractDiscounts () {
      this.$emit('update-discounts', this.discounts);
    },
    toNumber (number) {
      return Vue.toNumber(number);
    }
  }
}
</script>

<style>
  .id-cell.action-cell{
    width: 130px;
  }
</style>